import angular from 'angular';
import '../../buttons/button';

import { PaginationComponent } from './pagination.component';

angular
  .module('core.components.pagination', ['core.components.button'])
  .component('easyshipPagination', PaginationComponent);
